import { useRef } from "react";
import { Card, Progress } from "flowbite-react";
import { FaChevronDown, FaTrophy } from "react-icons/fa";
import confetti from "canvas-confetti";

const MetaCard = ({
  titulo,
  icone: Icone,
  quantidade,
  metas,
  progresso,
  trofeusGanhados,
  cor,
  tipo,
  alternarCard,
  cardsExpandidos,
}) => {
  const todasMetasBatidas = quantidade >= metas[metas.length - 1];
  const confettiRef = useRef(null);

  const dispararConfetes = () => {
    confetti({
      particleCount: 120,
      spread: 70,
      origin: { y: 0.6 }, // Define a posição dos confetes na tela
    });
  };

  return (
    <Card
      className="shadow-md text-center rounded-xl bg-white border border-gray-300 cursor-pointer relative"
      onClick={() => alternarCard(tipo)}
    >
      <FaChevronDown className="absolute top-3 right-3 text-gray-400" />
      <Icone className={`text-4xl text-${cor}-500 mx-auto mb-2`} />
      <h3 className="text-lg font-semibold text-gray-800">{titulo}</h3>

      {todasMetasBatidas ? (
        // Troféu gigante com efeito de confete ao clicar
        <div
          className="flex flex-col items-center justify-center my-4 cursor-pointer"
          onClick={dispararConfetes}
          ref={confettiRef}
        >
          <FaTrophy className="text-6xl text-yellow-500 animate-bounce" />
        </div>
      ) : (
        // Caso contrário, exibe progresso normal
        <>
          <p className="text-gray-600">
            {quantidade} de{" "}
            {metas.find((meta) => quantidade < meta) || metas[metas.length - 1]}
          </p>
          <Progress progress={progresso} color={cor} className="my-2" />
        </>
      )}

      {cardsExpandidos[tipo] && (
        <div className="mt-4">
          <h4 className="text-md font-semibold text-gray-700">Conquistas</h4>
          {trofeusGanhados.length > 0 ? (
            trofeusGanhados.map((trofeu, index) => (
              <div
                key={index}
                className="flex justify-between items-center text-gray-600"
              >
                <span>{trofeu.titulo}</span>
                <FaTrophy className="text-yellow-500 text-lg" />
              </div>
            ))
          ) : (
            <p className="text-gray-500">Nenhuma meta batida ainda</p>
          )}
        </div>
      )}
    </Card>
  );
};

export default MetaCard;
